import EFPicture from '@elem/compCommon/EFPicture';
import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EfSpec from '@elem/ui/ef-spec';

export default function AllWeather() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('theProduct.AllWeather');
    const { locale } = useRouter();

    const IMGS = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1731921087224/125w_weather_1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1731924328067/125w_weather_1_h5.jpg',
            title: t('tip_1'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1731921087469/125w_weather_2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1731924329011/125w_weather_2_h5.jpg',
            title: t('tip_2'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1731921087378/125w_weather_3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1731924329191/125w_weather_3_h5.jpg',
            title: t('tip_3'),
        },
    ];

    return (
        <div className={`${styles.TheComp} sp-125w-common`}>
            <EfSpec />

            <div className="info">
                <p className="subtitle">{t('label')}</p>
                <p className="title">{t('title')}</p>
                <p className="desc">{t('desc')}</p>
            </div>
            <ul className="imgs">
                {IMGS?.map((item: any, k: number) => (
                    <li className={`img img-${k}`} key={k}>
                        <EFPicture src={item.pc} srcPad={item.h5} srcMobile={item.h5} alt={t('title')} />
                        <p className="img-title">{item.title}</p>
                    </li>
                ))}
            </ul>
        </div>
    );
}
